import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import { getCdnUrl } from '../../helpers';

function CarouselCard({ ...props }) {
  const theme = useTheme();
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        height: 'auto',
        width: { xs: '100%', phone: '25rem' },
        minHeight: { xs: '20rem', phone: '20rem' },
        minWidth: { xs: '15rem', phone: '25rem' },
        gap: { xs: '2rem', phone: '5rem' },
        borderRadius: '0.75rem',
        border: `2px solid ${theme.palette.neutral.A600}`,
        padding: '2rem 1.5rem',
        background: 'linear-gradient(52deg, rgba(255, 255, 255, 0.12) 4.6%, rgba(1, 72, 183, 0.12) 95.39%)',
        boxShadow: '0 0.602px 1.807px -1.25px rgba(0, 0, 0, 0.36), 0 2.289px 6.866px -2.5px rgba(0, 0, 0, 0.32), 0 10px 30px -3.75px rgba(0, 0, 0, 0.13)',
      }}
    >
      <Typography
        variant="small_3"
        color={theme.palette.common.white}
        fontWeight={500}
        fontStyle="oblique"
        fontSize={{ xs: '0.875rem', phone: '1rem' }}
      >
        {props.description}
      </Typography>
      <Stack sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: { xs: '0.5rem', phone: '1rem' },
        justifyContent: 'flex-start',
        alignSelf: 'stretch',
      }}
      >
        <CardMedia
          component="img"
          image={getCdnUrl(props.image)}
          alt={props.company}
          style={{
            width: '100%',
            height: '100%',
            maxWidth: '3.25rem',
            maxHeight: '3.25rem',
            borderRadius: '50%',
          }}
        />
        <Typography
          variant="small_3"
          color={theme.palette.common.white}
          fontWeight={700}
          fontSize={{ xs: '0.875rem', phone: '1rem' }}
        >
          {props.company.toUpperCase()}
        </Typography>
      </Stack>
    </Card>
  );
}

CarouselCard.propTypes = {
  image: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default CarouselCard;
